import { handleActions } from 'redux-actions';
import { reduxKey, DEFAULT_PUSH_SUBSCRIPTIONS } from './constants';
import {
  dismissPWABanner,
  initPushSubscriptionsSuccess,
  savePWAInstallPrompt,
  setPushSubscriptionState,
  showPWABanner,
  updatePushSubscriptions,
} from './actions';
import { PushSubscriptionState, PwaState } from './types';

const defaultState: PwaState = {
  pushSubscriptionState: PushSubscriptionState.LOADING,
  send: DEFAULT_PUSH_SUBSCRIPTIONS,
  initialized: false,
  hidePWABanner: true,
  PWAInstallPrompt: null,
};

const actionHandlers = handleActions<PwaState, any>(
  {
    [setPushSubscriptionState.toString()]: (
      state,
      { payload }: ReturnType<typeof setPushSubscriptionState>
    ) => ({
      ...state,
      pushSubscriptionState: payload.newState,
    }),
    [savePWAInstallPrompt.toString()]: (
      state,
      { payload }: ReturnType<typeof savePWAInstallPrompt>
    ) => ({
      ...state,
      PWAInstallPrompt: payload,
    }),
    [showPWABanner.toString()]: (
      state,
      action: ReturnType<typeof showPWABanner>
    ) => ({
      ...state,
      hidePWABanner: false,
    }),
    [dismissPWABanner.toString()]: (
      state,
      action: ReturnType<typeof dismissPWABanner>
    ) => ({
      ...state,
      hidePWABanner: true,
    }),
    [initPushSubscriptionsSuccess.toString()]: (
      state,
      { payload }: ReturnType<typeof initPushSubscriptionsSuccess>
    ) => ({
      ...state,
      initialized: true,
      send: {
        ...state.send,
        ...payload,
      },
    }),
    [updatePushSubscriptions.toString()]: (
      state,
      { payload }: ReturnType<typeof updatePushSubscriptions>
    ) => ({
      ...state,
      send: {
        ...state.send,
        ...payload,
      },
    }),
  },
  defaultState
);

const reducers = {
  [reduxKey as string]: actionHandlers,
};

export default reducers;
